import {BaseService} from './BaseService';
import {HtmlMailImageDAO} from '../DAO/HtmlMailImageDAO';
import {HtmlMailImageDTOInterface} from '../DTO/HtmlMailImageDTOInterface';
import {HtmlMailImageStatusConst} from '../Enum/HtmlMailImageStatusConst';

export class HtmlMailImageService extends BaseService {

	/**
	 * 画像一覧取得
	 * @param status 取得する状態（HtmlMailImageStatusConst）。
	 *               指定しない場合は一覧非表示の画像も含めた全件を返す。
	 */
	public async getList(status?: string): Promise<Array<HtmlMailImageDTOInterface>> {

		const dao = new HtmlMailImageDAO(this);
		const list = await dao.getList(status);

		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}

		return list;
	}

	/**
	 * メッセージ作成画面で選択させる画像一覧を取得する。
	 * 一覧非表示にした画像を選択肢に出さないため、必ずACTIVEだけを取得する。
	 * サーバーは添付可否をstatusで判定していないため、絞り込みは画面側の責務。
	 */
	public async getActiveList(): Promise<Array<HtmlMailImageDTOInterface>> {

		return await this.getList(HtmlMailImageStatusConst.ACTIVE);
	}

	/**
	 * HTMLメール用の画像一覧を取得する。
	 * LINE対応済みの画像はLINE用画面で管理するため、ここでは除外する。
	 * @param status 取得する状態（HtmlMailImageStatusConst）
	 */
	public async getMailImageList(status: string): Promise<Array<HtmlMailImageDTOInterface>> {

		const list = await this.getList(status);

		if (list === null) {
			return null;
		}

		return list.filter(image => {
			if (image.lineReady === true) {
				return false;
			}
			return true;
		});
	}

	/**
	 * LINE用の画像一覧を取得する。
	 * URL・ALTが保存済みでLINEへ添付できる画像だけを返す。
	 * @param status 取得する状態（HtmlMailImageStatusConst）
	 */
	public async getLineImageList(status: string): Promise<Array<HtmlMailImageDTOInterface>> {

		const list = await this.getList(status);

		if (list === null) {
			return null;
		}

		return list.filter(image => {
			if (image.lineReady === true) {
				return true;
			}
			return false;
		});
	}

	/**
	 * 画像アップロード
	 * @param file アップロードするファイル
	 */
	public async upload(file: File, linkUrl: string, altText: string): Promise<HtmlMailImageDTOInterface> {

		const dao = new HtmlMailImageDAO(this);
		const result = await dao.upload(file, linkUrl, altText);

		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}

		return result;
	}

	/** URL・ALTを保存し、競合時は画面にエラーを伝える。 */
	public async update(id: number, revision: number, linkUrl: string, altText: string): Promise<HtmlMailImageDTOInterface> {
		const dao = new HtmlMailImageDAO(this);
		const result = await dao.update(id, revision, linkUrl, altText);
		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}
		return result;
	}

	/**
	 * 画像削除
	 * @param id ファイルID
	 */
	public async delete(id: number): Promise<any> {

		const dao = new HtmlMailImageDAO(this);
		const result = await dao.delete(id);

		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}

		return result;
	}

	/**
	 * 一覧非表示にする。
	 * 設定を残したまま、メッセージ作成画面の一覧に出さない状態へ変える。
	 * @param id ファイルID
	 */
	public async disable(id: number): Promise<any> {

		const dao = new HtmlMailImageDAO(this);
		const result = await dao.disable(id);

		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}

		return result;
	}

	/**
	 * 一覧非表示を解除して再表示する。
	 * @param id ファイルID
	 */
	public async enable(id: number): Promise<any> {

		const dao = new HtmlMailImageDAO(this);
		const result = await dao.enable(id);

		if (dao.getErrorObj()) {
			this.errorCopy(dao);
			return null;
		}

		return result;
	}
}
